import {useTranslation} from "react-i18next";
import {useIsMobile} from "../../../hooks/useIsMobile";
import {Tab, Tabs} from "react-bootstrap";
import PlayerScoreTable from "../../players/tables/PlayerScoreTable";
import {ACHIEVEMENT_IMAGES} from "../../../util/Constants";
import PlayerNameWithFlag from "../../players/PlayerNameWithFlag";
import type {TournamentAchievement, TournamentDetail} from "../../../types/domain";

interface FinalPlacementTabProps {
    tournament: TournamentDetail;
}

function FinalPlacementTab(props: FinalPlacementTabProps) {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    const getAchievements = () => {
        const groupedAchievements = Object.groupBy(props.tournament.achievements, ({ achievement }) => achievement);
        return (
          <>
              <div className="mt-3 mb-3">
                  <h3>{t("awardedAchievements")}</h3>
              </div>
              {Object.entries(groupedAchievements).map(([id, achievements]) => {
                  const list = achievements as TournamentAchievement[] | undefined;
                  if (!list || list.length === 0) return null;
                  return (
                  <div className="mb-4 d-flex" key={"tournament-achievement-" + id}>
                    <img src={ACHIEVEMENT_IMAGES[list[0].achievement as keyof typeof ACHIEVEMENT_IMAGES]} className="achievement-image" alt={list[0].achievement} />
                    <div className="d-inline-block ms-3" style={{verticalAlign: "middle"}}>
                      <div>
                        <div>
                          <b>{t("achievementTitle__" + list[0].achievement)}</b> - {t("achievementDescription__" + list[0].achievement)}
                        </div>
                        {list.map((achievement: TournamentAchievement) => (
                          <PlayerNameWithFlag key={"award-" + achievement.id} player={achievement.player} includeElo={false} />
                        ))}
                      </div>
                    </div>
                  </div>
                  );
              })}
          </>
        )
    }

    const scoreTable = <PlayerScoreTable scores={props.tournament.finalPlacements} hideBuchholz />;
    const achievements = getAchievements();

    return (
        <div>
          {isMobile ? (
            <Tabs defaultActiveKey="placement-tab" id="mobile-final-placement-tabs" variant="tabs" fill>
              <Tab eventKey="placement-tab" title={t("scoretable")}>{scoreTable}</Tab>
              <Tab eventKey="achievements-tab" title={t("achievements")}>{achievements}</Tab>
            </Tabs>
          ) : (
            <>
              <div className="left-half-responsive">{scoreTable}</div>
              <div className="right-half-responsive">{achievements}</div>
            </>
          )}
        </div>
    );
}

export default FinalPlacementTab
